module.exports = __webpack_public_path__ + "static/media/environmentWith.64778610.png";